export default {
  SEARCH_ENGINE_UPDATE_TERM: 'SEARCH_ENGINE_UPDATE_TERM',
  SEARCH_ENGINE_UPDATE_TERM_LIST: 'SEARCH_ENGINE_UPDATE_TERM_LIST',
  SEARCH_ENGINE_UPDATE_BACK_LOCATION: 'SEARCH_ENGINE_UPDATE_BACK_LOCATION'
}
